import styled from "@emotion/styled";
import { FC, ReactNode } from "react";

import { Checkbox, DesignToken, Heading, SpacingToken } from "@livechat/design-system-react-components";

import { LiveChatDataImportType } from "routes/settings/integrations/constants";
import { withVar } from "themes/helpers";

interface IProps {
  type: LiveChatDataImportType;
  title: ReactNode;
  onClick: (option: LiveChatDataImportType) => void;
  selected: boolean;
  addons?: ReactNode;
}

export const ImportOptionCard: FC<IProps> = ({ type, title, onClick, selected, addons }) => {
  const handleClick = (): void => onClick(type);

  return (
    <Wrapper htmlFor={type} selected={selected}>
      <StyledCheckbox id={type} onChange={handleClick} checked={selected} />
      <Title size="xs" customColor={withVar(DesignToken.ContentBasicPrimary)}>
        {title}
      </Title>
      {addons}
    </Wrapper>
  );
};

const Wrapper = styled.label<{ selected: boolean }>`
  display: flex;
  gap: ${withVar(SpacingToken.Spacing2)};
  align-items: center;

  box-sizing: border-box;
  min-height: 56px;
  border-radius: ${withVar(SpacingToken.Spacing2)};
  border: 1px solid
    ${(p): string => withVar(p.selected ? DesignToken.ActionPrimaryDefault : DesignToken.BorderBasicSecondary)};
  padding: ${withVar(SpacingToken.Spacing3)} 16px;
  transition: border-color 0.2s ease-in-out;
  cursor: pointer;
`;

const Title = styled(Heading)`
  padding-left: ${withVar(SpacingToken.Spacing1)};
`;

const StyledCheckbox = styled(Checkbox)<{ checked: boolean }>`
  padding-top: ${withVar(SpacingToken.Spacing05)};

  input {
    &:focus {
      box-shadow: none;
    }
  }
`;
